import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", { d: "M0 14.625c0 .622.503 1.125 1.125 1.125h1.923a2.81 2.81 0 0 0 2.577 1.688 2.81 2.81 0 0 0 2.577-1.688h8.673c.622 0 1.125-.503 1.125-1.125s-.503-1.125-1.125-1.125H8.202a2.81 2.81 0 0 0-2.577-1.687A2.81 2.81 0 0 0 3.048 13.5H1.125C.503 13.5 0 14.003 0 14.625m4.5 0a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0M11.25 9a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0m1.125-2.812a2.81 2.81 0 0 0-2.577 1.687H1.125a1.124 1.124 0 1 0 0 2.25h8.673a2.81 2.81 0 0 0 2.577 1.688 2.81 2.81 0 0 0 2.577-1.688h1.923a1.124 1.124 0 1 0 0-2.25h-1.923a2.81 2.81 0 0 0-2.577-1.687M6.75 4.5a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m2.577-2.25A2.81 2.81 0 0 0 6.75.563 2.81 2.81 0 0 0 4.173 2.25H1.125a1.124 1.124 0 1 0 0 2.25h3.048A2.81 2.81 0 0 0 6.75 6.188 2.81 2.81 0 0 0 9.327 4.5h7.548a1.124 1.124 0 1 0 0-2.25z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }